"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgRiskLevelGoodWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 96,
    viewBox: "0 0 80 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.826 95.999c6.474.101 12.139-5.03 13.084-11.708 0 0 5.17-21.361 5.088-26.4a196.91 196.91 0 01-.023-6c.01-1.298.023-2.962.023-5.843 0-7.087-8.218-12.566-15.265-12.488H39.564V14.05C39.774 6.263 33.944.005 26.48 0h-3.908c-3.275 0-5.883 2.795-5.815 6.244v16.39c-.205 6.37-2.499 12.8-6.542 17.95L0 51.903.038 81.17C.074 89.355 6.298 96.037 13.849 96h47.977zm-28.262-82.03V39.56H64.8c2.066-.023 4.595.817 6.563 2.323 1.977 1.512 2.635 3.065 2.635 4.165 0 1.315-.002 2.378-.007 3.272H59.84v6h14.127c.005.735.015 1.586.032 2.668.01.575-.168 2.183-.611 4.772H59.84v6h12.4c-.202.985-.412 1.979-.623 2.96a454.32 454.32 0 01-1.204 5.44H55.999v6h13.012l-.001.002-.04.288c-.56 3.946-3.858 6.6-7.05 6.55l-.047-.001H13.818c-3.786.019-7.752-3.518-7.78-8.848v-.008l-.035-26.937 8.804-9.754.127-.162c4.838-6.164 7.575-13.825 7.82-21.464l.003-.096V6.185l-.001-.06A.511.511 0 0122.767 6h3.71c3.842.004 7.214 3.225 7.09 7.888l-.003.08z",
    fill: "url(#riskLevelGoodWork_svg__riskLevelGoodWork_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "riskLevelGoodWork_svg__riskLevelGoodWork_svg__paint0_linear",
    x1: 100.07,
    y1: 53.09,
    x2: 34.3,
    y2: -15.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: props.color || "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: props.color || "#fff",
    stopOpacity: 0.9
  }))));
}

var _default = SvgRiskLevelGoodWork;
exports["default"] = _default;